import { Controller } from "@hotwired/stimulus";

export default class GalleryModeFilterController extends Controller {
  static targets = ["modeButton", "section"];
  static values = { active: String };

  declare readonly modeButtonTargets: HTMLElement[];
  declare readonly sectionTargets: HTMLElement[];
  declare activeValue: string;

  activeValueChanged(): void {
    this.updateButtons();
    this.updateSections();
  }

  selectMode(event: Event): void {
    const button = event.currentTarget as HTMLElement;
    this.activeValue = button.dataset.mode || "";
  }

  private updateButtons(): void {
    for (const btn of this.modeButtonTargets) {
      const isActive =
        this.activeValue === "" ? btn.dataset.mode === "" : btn.dataset.mode === this.activeValue;
      btn.classList.toggle("bg-primary", isActive);
      btn.classList.toggle("text-primary-content", isActive);
      btn.classList.toggle("font-semibold", isActive);
      btn.classList.toggle("shadow-sm", isActive);
      btn.classList.toggle("text-base-content/60", !isActive);
      btn.classList.toggle("font-medium", !isActive);
    }
  }

  private updateSections(): void {
    for (const section of this.sectionTargets) {
      const match = this.activeValue === "" || section.dataset.mode === this.activeValue;
      section.classList.toggle("hidden", !match);
    }
  }
}
